import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValueProposition } from 'ng2-app/models/dto/value-proposition.model';
import { transition, trigger, useAnimation } from '@angular/animations';
import { fadeIn, fadeOut } from 'ng-animate';

@Component({
  selector: 'app-value-props-dropdown',
  templateUrl: './value-props-dropdown.component.html',
  styleUrls: ['./value-props-dropdown.component.scss'],
  animations: [
    trigger('listAnimation', [
      transition(':enter', useAnimation(fadeIn, { params: { timing: 0.2 } })),
      transition(':leave', useAnimation(fadeOut, { params: { timing: 0.2 } })),
    ]),
  ],
  standalone: false
})
export class ValuePropsDropdownComponent {
  @Input() valueProps: ValueProposition[];
  @Input() isLoading: boolean = false;
  @Input() isEmpty: boolean = false;
  @Input() disabled: boolean = false;
  @Input() eventDelay: number = 300; //ms
  @Output() add = new EventEmitter <ValueProposition>();
  @Output() addAll = new EventEmitter<undefined>();
  @Output() removeAll = new EventEmitter<undefined>();

  menuOpen: boolean = false;

  constructor() {}

  valuePropId(i, valueProp) {
    return valueProp.id;
  }

  onSelect(valueProp: ValueProposition, event: MouseEvent) : void {
    if (this.valueProps.length > 1) {
      event.stopPropagation();
      this.add.emit(valueProp);
    } else {
      this._delayedEmit(this.add, valueProp);
    }
  }

  onAddAll(): void {
    this._delayedEmit(this.addAll);
  }

  onRemoveAll(): void {
    this._delayedEmit(this.removeAll);
  }

  private _delayedEmit(emitter: EventEmitter<any>, value?: any) {
    setTimeout(() => emitter.emit(value), this.eventDelay);
  }
}
